import { useDisclosure } from '@chakra-ui/react'
import React, { useEffect } from 'react'
import AddTagModal from './AddTagModal'
import ConfirmationModal from './ConfirmationModal'
import ChangeContextModal from './ChangeContextModal'
import ProlongationDetailModal from './ProlongationDetailModal'
import NoContextModal from './NoContextModal'
import {
    useChangeContextModalStore,
    useConfirmationModalStore,
    useStudentsTagsModalStore,
    useProlongationDetailModalStore,
} from '../../store/modalsStore'

function Modals() {
    const setTagsDisclosure = useStudentsTagsModalStore(state => state.setDisclosure)
    const tagsDisclosure = useDisclosure()

    const setConfirmationDisclosure = useConfirmationModalStore(state => state.setDisclosure)
    const confirmationDisclosure = useDisclosure()

    const setChangeContextDisclosure = useChangeContextModalStore(state => state.setDisclosure)
    const contextModalDisclosure = useDisclosure()

    const setProlongationDetailDisclosure = useProlongationDetailModalStore(state => state.setDisclosure)
    const prolongationDetailModalDisclosure = useDisclosure()

    useEffect(() => {
        setTagsDisclosure(tagsDisclosure)
        setConfirmationDisclosure(confirmationDisclosure)
        setChangeContextDisclosure(contextModalDisclosure)
        setProlongationDetailDisclosure(prolongationDetailModalDisclosure)
    }, [])

    return (
        <>
            <AddTagModal
                isOpen={tagsDisclosure.isOpen}
                onClose={tagsDisclosure.onClose}
            />
            <ConfirmationModal
                isOpen={confirmationDisclosure.isOpen}
                onClose={confirmationDisclosure.onClose}
            />
            <ChangeContextModal
                isOpen={contextModalDisclosure.isOpen}
                onClose={contextModalDisclosure.onClose}
            />
            <ProlongationDetailModal
                isOpen={prolongationDetailModalDisclosure.isOpen}
                onClose={prolongationDetailModalDisclosure.onClose}
            />
            <NoContextModal />
        </>
    )
}

export default Modals
